var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component } from 'vue-property-decorator';
import { useStore } from 'vuex-simple';
import { container } from '@/dependency-injection';
import BaseTable from '@/components/base/BaseTable.vue';
import TableRow from '@/components/shared/TableRow.vue';
import TableCell from '@/components/shared/TableCell.vue';
import TableCellCreatedModified from '@/components/shared/TableCell_CreatedModified.vue';
import TableCellExpandedChips from '@/components/shared/TableCell_ExpandedChips.vue';
import TableIcon from '@/components/shared/TableIcon.vue';
import TableIconEdit from '@/components/shared/TableIcon_Edit.vue';
import TableIconDelete from '@/components/shared/TableIcon_Delete.vue';
import TableIconRestore from '@/components/shared/TableIcon_Restore.vue';
import TableIconView from '@/components/shared/TableIcon_View.vue';
import TableIconCopy from '@/components/shared/TableIcon_Copy.vue';
import TableButton from '@/components/shared/TableButton.vue';
import TableButtonEdit from '@/components/shared/TableButton_Edit.vue';
import TableButtonDelete from '@/components/shared/TableButton_Delete.vue';
import TableButtonRestore from '@/components/shared/TableButton_Restore.vue';
import TableButtonView from '@/components/shared/TableButton_View.vue';
import TableButtonExpandable from '@/components/shared/TableButton_Expandable.vue';
import TableChipDeleted from '@/components/shared/TableChip_Deleted.vue';
var TableMixin = /** @class */ (function (_super) {
    __extends(TableMixin, _super);
    function TableMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = useStore(_this.$store);
        _this.service = {};
        _this.serviceSymbol = Symbol('');
        return _this;
    }
    TableMixin.prototype.mounted = function () {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                this.service = container.get(this.serviceSymbol);
                return [2 /*return*/];
            });
        });
    };
    /**
     * Open the delete prompt dialog with the item passed in
     * Checks if item can be deleted using the service, then updates the itemCanBeDeleted property
     * @param item Item to set as the currently selected item
     */
    TableMixin.prototype.openDeleteDialog = function (item, skipCanDelete) {
        if (skipCanDelete === void 0) { skipCanDelete = false; }
        return __awaiter(this, void 0, void 0, function () {
            var itemCanBeDeleted;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(skipCanDelete === false)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.service.canDeleteItem(item)];
                    case 1:
                        itemCanBeDeleted = _a.sent();
                        this.setItemCanBeDeleted(itemCanBeDeleted);
                        _a.label = 2;
                    case 2:
                        // open the delete dialog
                        this.store.dialog.openDeleteDialog(item);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Set if the item can be deleted or not
     * @param canBeDeleted if the item can be deleted
     * @param message any message indicating why an item can't be deleted
     */
    TableMixin.prototype.setItemCanBeDeleted = function (canBeDeleted, message) {
        if (message === void 0) { message = ''; }
        this.store.dialog.setItemCanBeDeleted({ value: canBeDeleted, message: message });
    };
    /**
     * Set if the item can be deleted(with warning) or not
     * @param canBeDeleted if the item can be deleted
     * @param message any message indicating why an item can't be deleted
     */
    TableMixin.prototype.setItemHasWarning = function (canBeDeleted, message) {
        if (message === void 0) { message = ''; }
        this.store.dialog.setItemHasWarning({ value: canBeDeleted, message: message });
    };
    /**
     * Open the restore prompt dialog with the item passed in
     * Checks if item can be restored using the service, then updates the itemCanBeRestored property
     * @param item Item to set as the currently selected item
     */
    TableMixin.prototype.openRestoreDialog = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var itemCanBeRestored;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service.canRestoreItem(item)];
                    case 1:
                        itemCanBeRestored = _a.sent();
                        this.store.dialog.setItemCanBeRestored(itemCanBeRestored);
                        // open the restore dialog
                        this.store.dialog.openRestoreDialog(item);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Open the dialog with the item and mode passed in
     * @param item Item to set as the currently selected item
     * @param mode Mode of the dialog, e.g. 'cancelling'
     */
    TableMixin.prototype.openDialog = function (item, mode) {
        this.store.dialog.openDialog({ mode: mode, item: item });
    };
    /**
     * Open the filter side sheet
     */
    TableMixin.prototype.openFilterSidesheet = function () {
        var _this = this;
        // if the CRUD side sheet is visible, then close it before opening the filter side sheet
        if (this.store.managementPage.crudSidesheetVisible) {
            this.store.managementPage.closeCrudSidesheet();
        }
        // open the filter side sheet
        this.$nextTick(function () {
            _this.store.managementPage.openFilterSidesheet();
        });
    };
    TableMixin.prototype.toggleFilterSidesheet = function () {
        var _this = this;
        // if the CRUD side sheet is visible, then close it before opening the filter side sheet
        if (this.store.managementPage.crudSidesheetVisible) {
            this.store.managementPage.closeCrudSidesheet();
        }
        // toggle the filter side sheet
        this.$nextTick(function () {
            _this.store.managementPage.filterSidesheetVisible
                ? _this.store.managementPage.closeFilterSidesheet()
                : _this.store.managementPage.openFilterSidesheet();
        });
    };
    Object.defineProperty(TableMixin.prototype, "loading", {
        get: function () {
            return this.store.loading;
        },
        set: function (value) {
            this.store.setLoading(value);
        },
        enumerable: false,
        configurable: true
    });
    TableMixin.prototype.closeCrudSidesheet = function () {
        this.store.managementPage.closeCrudSidesheet();
    };
    /**
     * Open the CRUD side sheet in create mode with the item passed in
     * @param item Item to set as the currently selected item
     */
    TableMixin.prototype.openCrudSidesheetCreate = function (item) {
        this.openCrudSidesheet(item, 'create');
    };
    /**
     * Open the CRUD side sheet in read mode with the item passed in
     * @param item Item to set as the currently selected item
     */
    TableMixin.prototype.openCrudSidesheetRead = function (item) {
        this.openCrudSidesheet(item, 'read');
    };
    /**
     * Open the CRUD side sheet in update mode with the item passed in
     * @param item Item to set as the currently selected item
     */
    TableMixin.prototype.openCrudSidesheetUpdate = function (item) {
        this.openCrudSidesheet(item, 'update');
    };
    /**
     * Open the CRUD side sheet in delete mode with the item passed in
     * @param item Item to set as the currently selected item
     */
    TableMixin.prototype.openCrudSidesheetDelete = function (item) {
        this.openCrudSidesheet(item, 'delete');
    };
    Object.defineProperty(TableMixin.prototype, "step", {
        /**
         * Get the step
         */
        get: function () {
            return this.store.steppedPage.step;
        },
        /**
         * Set the step
         */
        set: function (data) {
            this.store.steppedPage.setStep(data);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Open the CRUD side sheet with the item passed in
     * @param item Item to set as the currently selected item
     * @param mode The mode to open the CRUD sidesheet in
     */
    TableMixin.prototype.openCrudSidesheet = function (item, mode) {
        var _this = this;
        this.store.setLoading(true);
        // if the filter side sheet is visible, then close it before opening the CRUD side sheet
        if (this.store.managementPage.filterSidesheetVisible) {
            this.store.managementPage.closeFilterSidesheet();
        }
        // open the CRUD sidesheet
        this.$nextTick(function () {
            _this.store.managementPage.openCrudSidesheet({ item: __assign({}, item), mode: mode });
            _this.store.setLoading(false);
        });
    };
    TableMixin = __decorate([
        Component({
            components: {
                'base-table': BaseTable,
                'table-row': TableRow,
                'table-cell': TableCell,
                'table-cell-created-modified': TableCellCreatedModified,
                'table-cell-expanded-chips': TableCellExpandedChips,
                'table-icon': TableIcon,
                'table-icon-edit': TableIconEdit,
                'table-icon-delete': TableIconDelete,
                'table-icon-restore': TableIconRestore,
                'table-icon-view': TableIconView,
                'table-icon-copy': TableIconCopy,
                'table-button': TableButton,
                'table-button-edit': TableButtonEdit,
                'table-button-delete': TableButtonDelete,
                'table-button-restore': TableButtonRestore,
                'table-button-view': TableButtonView,
                'table-button-expandable': TableButtonExpandable,
                'table-chip-deleted': TableChipDeleted,
            },
        })
    ], TableMixin);
    return TableMixin;
}(Vue));
export default TableMixin;
